import { Skeleton } from 'antd';

function BooksViewerLoader() {
  return (
    <div className="bible-translation-viewer-loader">
      <div className="bible-translation-viewer-loader__item">
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
      </div>
      <div className="bible-translation-viewer-loader__item">
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
      </div>
      <div className="bible-translation-viewer-loader__item">
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
      </div>
    </div>
  );
}

export default BooksViewerLoader;
